export default {
  dbl_common_all: "全部",
  dbl_common_overall: "聚合数据",
  dbl_common_save: "保存",
  dbl_common_save_as: "另存为",
  dbl_common_clear: "清空",
  dbl_common_confirm: "确认",
  dbl_common_reset: "重置",
  dbl_common_cancel: "取消",
  dbl_common_back: "回退",
  dbl_common_close: "关闭",
  dbl_common_stop: "停止",
  dbl_common_save_to: "保存并进入报表界面",
  dbl_common_search: "搜索",
  dbl_common_search_nothing: "搜索无结果",
  dbl_common_nothing: "无结果",
  dbl_common_add: "新增",
  dbl_common_delete: "删除",
  dbl_common_no_data: "暂无数据",
  dbl_common_no_data2: "暂无数据",
  dbl_common_no_filter_data: "当前筛选条件下无数据",
  dbl_common_sql_error: '数据源存在问题，请检查数据源。',
  dbl_common_not_found: '找不到搜索项',
  dbl_common_leave: "离开",
  dbl_common_leave_message: "当前{name}页面尚未保存，如离开将会丢失所有内容。",
  dbl_common_explore_leave_message: "如离开将会丢失所有内容。",
  dbl_common_loading: "加载中...",
  dbl_common_load_fail: "加载失败",
  dbl_common_refresh: "，刷新重试",
  dbl_common_not_search: "未找到搜索内容,",
  dbl_common_go_back_old: "返回原列表",
  dbl_common_error_code: "错误码",
  dbl_common_select_all: "全选",
  dbl_common_clear_all: "清除",
  dbl_common_return: "返回",
  dbl_common_day: "日",
  dbl_common_week: "周",
  dbl_common_month: "月",
  // 图表类型
  dbl_common_table_title: "表格",
  dbl_common_bar_title: "柱状图",
  dbl_common_line_title: "折线图",
  dbl_common_pie_title: "饼状图",
  dbl_common_table: "基础表格",
  dbl_common_line: "基础折线图",
  dbl_common_bar: "基础柱状图",
  dbl_common_stack_bar: "堆叠柱状图",
  dbl_common_pie: "饼图",
  dbl_common_delete_successfully: '删除成功',
  dbl_common_delete_failed: '删除失败',
  dbl_common_create_time: '创建时间',
  dbl_common_creator: '创建人',
  dbl_common_operation: '操作',
  dbl_common_status: "状态",
  dbl_common_updater: "更新人",
  dbl_common_last_updater: "最近更新人",
  dbl_common_editable_person: "可编辑人员",
  dbl_common_edit: "编辑",
  dbl_common_publish: "发布",
  dbl_common_un_publish: "撤销发布",
  dbl_common_published: "已发布",
  dbl_common_un_published: "未发布",
  dbl_common_total: "共 {total} 项",
  dbl_common_select_placeholder: '请选择',
  dbl_common_select_no_data: '暂无数据',
  dbl_common_dashboard_title: '报表',
  dbl_common_name: '名称',
  dbl_common_customize: '自定义',
  dbl_common_customize_placeholder: '请输入选项名称',
  dbl_common_publish_successfully: '{name}报表发布成功',
  dbl_common_publish_failed: '发布失败！错误码{code}',
  dbl_common_un_publish_successfully: '{name}报表取消发布成功',
  dbl_common_un_publish_failed: '撤销发布失败！错误码{code}',
  dbl_no_data: '暂无数据',
  dbl_common_least_select_one: '请至少保留一个选项',
  
  dbl_common_valida_required: '必填',
  dbl_common_save_fail: "保存失败",
  dbl_common_save_success: "保存成功",
  
  dbl_common_include: '包含',
  dbl_common_exclude: '排除',
  
  dbl_common_cannot_be_empty: '不能为空',
  dbl_common_please_select: '请选择{name}',
  
  dbl_common_dynamic_time: '动态时间',
  dbl_common_static_time: '静态时间',
  dbl_common_static_time_info: '日期不会随时间而改变。如果您选择2023.1.1至2023.1.7，则日期始终为2023.1.1至2023.1.7',
  
  dbl_common_dod_day: '日环比',
  dbl_common_dod_date: '日环比',
  dbl_common_dod_week: '周环比',
  dbl_common_dod_month: '月环比',
  dbl_common_sdlw_day: '上周同期',
  dbl_common_sdlw_date: '上周同期',
  dbl_common_sdlw_week: '上月同期',
  dbl_common_sdlw_month: '去年同期',
  dbl_common_change: '变化率',
  dbl_common_trend: '趋势线',
  dbl_common_show_static_time: '显示日期',
  dbl_common_current_day: '当天',
  dbl_common_current_date: '当天',
  dbl_common_current_week: '当周',
  dbl_common_current_month: '当月',
  
  dbl_common_access: '权限',
  dbl_common_no_access: '无权限',
  dbl_common_no_edit_access_tips: '无编辑权限，若需预览图表，可在报表中查看',
  
  dbl_common_download: '下载',
  dbl_common_transpose: '转置',
  
  dbl_common_search_result: '搜索结果 ({count})',
  dbl_common_selector_placeholder: '请选择',
  dbl_common_string_selector_placeholder: '请选择值',
  
  dbl_common_valid_name: "请输入汉字、数字、大小写字母、空格、小括号、下划线、中划线、中括号。",
  dbl_common_valid_name_length: "不能超过{count}个字符",
  
  dbl_common_dashboard_valid_name: "请输入汉字、数字、大小写字母、小括号、下划线、中划线、空格。",
  dbl_common_no_permission: '无权限',
  dbl_common_no_permission_desc:
    '您当前以“查看者”身份登录，仅可查看。若需修改，请向管理员申请“编辑者”或更高权限。',
  
  dbl_common_fullscreen: '全屏模式',
  dbl_common_copy: '复制',
  dbl_common_copy_success: '复制成功!',
  dbl_common_copy_error: '复制失败!',
  
  dbl_common_others: '其他',
  dbl_common_filter_invalid: '筛选器无效',
  dbl_common_default_value_invalid: '默认值无效',
  dbl_common_default_value_invalid_info: '默认值与关联筛选器的选项不匹配，请检查并调整默认值设置。',
  dbl_common_filter_field_error: '字段不存在',
  dbl_common_filter_reference_field_error: '引用字段不存在',
  
  dbl_common_default: '默认',
  
  dbl_common_sort: '排序',
  dbl_common_sort_reset: '重置排序',
  dbl_common_sort_clear: '清除排序',
  dbl_common_yes: '是',
  dbl_common_no: '否',
  dbl_common_retry: '重试',
  
  dbl_common_detail: '详情',
  dbl_common_expand: "展开",
  dbl_common_collapse: "收起",

  dbl_common_dashboard_disabled: '该图表已在仪表板中',
  dbl_common_pascal_custom: '自定义',
  
  dbl_common_set_up: '设置',

  dbl_common_number: '数值',
  dbl_common_refresh_text: '刷新',
  dbl_common_refresh_click: '点击重试',

  dbl_common_download_type: '文件格式',
};